// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__b76nS","fill":"styles_fill__6HX7J","blackOutline":"styles_blackOutline__mm2Xx","whiteOutline":"styles_whiteOutline__NTFds"};